var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twotone-closed_caption-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4574",
    "data-name": "Caminho 4574",
    d: "M0,0H12V12H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4575",
    "data-name": "Caminho 4575",
    d: "M6.855,8.665a2.5,2.5,0,1,0,0,1.67L6.97,10H10v2h1V10h1V9H6.97ZM4.5,11A1.5,1.5,0,1,1,6,9.5,1.5,1.5,0,0,1,4.5,11Z",
    transform: "translate(-1 -3.5)",
    fill: "none",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4576",
    "data-name": "Caminho 4576",
    d: "M3.5,5a3.5,3.5,0,1,0,3.16,5H8v2h3V10h1V7H6.66A3.5,3.5,0,0,0,3.5,5ZM11,9H10v2H9V9H5.97l-.115.335a2.5,2.5,0,1,1,0-1.67L5.97,8H11ZM3.5,7A1.5,1.5,0,1,0,5,8.5,1.5,1.5,0,0,0,3.5,7Zm0,2A.5.5,0,1,1,4,8.5.5.5,0,0,1,3.5,9Z",
    transform: "translate(0 -2.5)",
    fill: "#48af77"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/key-icon.00178e8426acaba0dee68761c198bbc7.svg";
export { ForwardRef as ReactComponent };